module.exports = __webpack_public_path__ + "static/logo-flower-text-63b5cf9c493b35f477a7643ec15d9cda.png";